export const MAX_CONTENT_WIDTH = '1200px';
export const BUTTON_WIDTH = '150px';
